import { Component } from '@angular/core';

@Component({
  selector: 'identity-footer',
  template: `
  <hr>
  <footer>
  </footer>`
})

export class FooterComponent {
  today: number;
  constructor() {
    this.today = Date.now();
  }
}
